/* jslint esversion: 6 */
/**
 * Scroll Transition
 *
 * Animate local scrolling.
 *
 * @author Dylan James Wagner
 *
 * @todo consider settings.offset element(s) as offset default. parseFloat($('#header').css('height'))
 */
const $ = window.jQuery;
const s = {
	$window           : $(window),
	$wpadminbar       : $('#wpadminbar'),
	scrollDuration    : 500,
	scrollOffset      : parseFloat($('.header').css('height')), // default 0
	directionalOffset : true,
};

function init() {

	$(window).on('load',function() {

		/** load location hash */
		scroll(window.location.hash, 0); // no scrollDuration, no scrollOffset
	});

	events();
}

function events() {

	/** hash & search+hash */
	// $('a[href^="#"]') // + window.location.search
	// $('a[href^="#"], a[href$="' + window.location.hash + '"]')
	// $('a[href^="#"], a[href$="' + window.location.search + window.location.hash + '"]')
	$('a[href^="#"], a[href$="' + window.location.hash + '"]:not(#comment-reply-link):not(#cancel-comment-reply-link)') // + window.location.search
		.on('click', function(event) { event.preventDefault();
			scroll(this.hash);
		});
}

function scroll(hash, duration = s.scrollDuration, offset = s.scrollOffset) {
	// console.log('scroll', hash);

	if (hash.length !== 0) {
		const $target = $(hash);

		s.wpadminbarHeight = s.$wpadminbar.length ? parseFloat(s.$wpadminbar.css('height')) : 0;

		if ($target.length) {
			let scrollTop = $target.offset().top - (offset + s.wpadminbarHeight);

			if (s.directionalOffset) {

				if ($target.offset().top > s.$window.scrollTop()) {
					scrollTop = $target.offset().top - s.wpadminbarHeight;
				}
			}

			$('html, body').animate({
				scrollTop : scrollTop,
			}, duration);
		}
	}
}

export {init as default, scroll};
